
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { PushConfigFilesRequestBody, GetConfigurationFileStatusesRequestBody } from './types';
import { PushConfigFilesResponseBody } from '../entities/config-files-v1/push-config-files-response-body';
import { ConfigFileStatusesResponseBody } from '../entities/config-files-v1/config-file-statuses-response-body';
import { axiosInstance } from "../axios-instance";

class ConfigurationFiles {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  pushConfigFiles(
    input: PushConfigFilesRequestBody,
  ): Promise<AxiosResponse<PushConfigFilesResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<PushConfigFilesResponseBody>(`${this.baseUrl}/pushConfigFiles`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  getConfigurationFileStatuses(
    input: GetConfigurationFileStatusesRequestBody,
  ): Promise<AxiosResponse<ConfigFileStatusesResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<ConfigFileStatusesResponseBody>(`${this.baseUrl}/configFileStatuses`, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default ConfigurationFiles;
